export type TYPE_ENV_SANDBOX = "sandbox";
export type TYPE_ENV_PRODUCTION = "prod";
export type APPLICATION_ENV = TYPE_ENV_SANDBOX | TYPE_ENV_PRODUCTION;
export const ENV_SANDBOX: TYPE_ENV_SANDBOX = "sandbox";
export const ENV_PRODUCTION: TYPE_ENV_PRODUCTION = "prod";

export type API_SERVICE = typeof SERVICE_API | typeof SERVICE_NOTIFICATIONS;
export const SERVICE_API = "api";
export const SERVICE_NOTIFICATIONS = "notifications";
